import { Fragment, ReactNode, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getAllActions } from "../../API/Actions/actionService";
import { Action } from "../../data/types";
import bg from "../../images/Jardin Familiaux (1).jpg";
import backgroundImage from "../../images/background2.png";

import { Button } from "../ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  CarouselPreviousWithDots,
} from "../ui/carousel";

type Props = {
  children?: ReactNode;
};

const CardContentData = [
  {
    id: 1,
    image: backgroundImage,
    title: "Card 1",
    link: "/actions",
    description:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsa repudiandae sit est laudantium quibusdam nam dolore. Illo  facilis provident eaque labore, assumenda cumque omnis fugit excepturi minus. Aut, placeat asperiores.",
  },

  {
    id: 2,
    image: backgroundImage,
    title: "Card 2",
    link: "/actions",
    description:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsa repudiandae sit est laudantium quibusdam nam dolore. Illo  facilis provident eaque labore, assumenda cumque omnis fugit excepturi minus. Aut, placeat asperiores.",
  },
  {
    id: 3,
    image: backgroundImage,
    title: "Card 3",
    link: "/actions",
    description:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsa repudiandae sit est laudantium quibusdam nam dolore. Illo  facilis provident eaque labore, assumenda cumque omnis fugit excepturi minus. Aut, placeat asperiores.",
  },
];

const ActionHomeSection = (props: Props) => {
  const [actions, setActions] = useState<Action[]>([]);
  const fetchData = async () => {
    const response = await getAllActions();
    setActions(response?.actions);
  };
  useEffect(() => {
    fetchData();
  }, []);

  const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;

  return (
    <Fragment>
      <div
        className="relative flex items-center justify-center h-full p-4 mt-8 md:p-24"
        style={{
          zIndex: 0,
        }}
      >
        <div
          className="absolute inset-0 bg-cover "
          style={{
            backgroundImage: `linear-gradient(rgba(60, 198,247, 0.5), rgba(60, 198,247, 0.5)), url(${backgroundImage})`,
            backgroundSize: "100% 100%",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            //opacity: "50%",
            zIndex: -1,
          }}
        ></div>
        <div className="container">
          <div className="text-center">
            <div className="text-3xl font-bold">Nos initiatives </div>
            <p className="text-black ">
              Pour une gestion responsable de l'eau et la valorisation de notre
              patrimoine
            </p>
          </div>
          <div className="flex flex-col justify-center mt-4 space-x-16 md:mt-20 lg:flex-row">
            <div className="mt-1 sm:mr-0 lg:mr-10 lg:w-1/4">
              <p className="text-justify">
                AQUAVESC s'engage activement pour préserver l'eau en incitant
                chacun à adopter des éco-gestes simples, tout en encourageant
                une gestion responsable et durable de cette ressource.
              </p>
              <p className="mt-4 text-justify">
                Fort de son patrimoine historique, AQUAVESC sensibilise à la
                préservation de l'eau, ressource précieuse et en voie de
                raréfaction, à travers des actions éducatives, des événements
                communautaires et des programmes scolaires, tout en valorisant
                l’héritage lié à l’eau.
              </p>
            </div>
            <div className="flex justify-center mt-2 space-x-3 lg:w-1/2">
              <Carousel
                opts={{ align: "start" }}
                className="w-full"
                cardContentData={actions}
              >
                <CarouselContent>
                 {actions.map((_, index) => (
                  <CarouselItem key={index}>
                    <div className="flex p-1 space-x-5">
                      {[
                        actions[index],
                        actions[(index + 1) % actions.length],
                      ].map((card) => {
                        const imageUrl = typeof card.image === "string" && card.image.trim() !== ""
                        ? `${uploadUrl}/initiatives/${card.image}`
                        : null;
                        return (
                          <Card key={card.id} className="w-full">
                            <CardHeader>
                              <CardTitle className="p-4">
                               
                                {imageUrl && (
                                  <img src={imageUrl} alt={card.title} className="object-cover w-full h-[200px]" />
                                )}
                              </CardTitle>
                            </CardHeader>
                            <CardContent className="h-40 overflow-hidden">
                              <p className="font-bold">{card.title}</p>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: card.description.length > 100
                                    ? card.description.substring(0, 100) + "..."
                                    : card.description
                                }}
                              />
                            </CardContent>
                            <CardFooter className="flex items-center justify-center w-full">
                              <Link to={`/initiatives/${card.slug}`} className="w-full sm:mt-10">
                                <Button className="w-full sm:mt-10">Voir plus</Button>
                              </Link>
                            </CardFooter>
                          </Card>
                        );
                      })}
                    </div>
                  </CarouselItem>
                ))}

               
                </CarouselContent>
                <CarouselPreviousWithDots cardContentData={actions} />
                <CarouselPrevious className="text-white bg-primary" />
                <CarouselNext className="text-white bg-primary" />
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ActionHomeSection;
